"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gemCombine = exports.gemToRuby = exports.gemToParts = exports.gemToText = exports.gemToReading = exports.requireFurigana = exports.gemStringFromReading = exports.splitWhen = exports.toGemString = exports.requireUnicodeBMP = exports.requireType = exports.isGemString = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const jpn = __importStar(require("./japaneseUtils"));
/**
 * Determines if a string is a legal gem formatted string
 * @param text: The string to test.
 * @returns Returns the validated gem string, or throws an exception.
 */
function isGemString(text) {
    try {
        return text === toGemString(text);
    }
    catch {
        return false;
    }
}
exports.isGemString = isGemString;
/**
 * Requires the parameter to be of the specified type, or throws an exception.
 * @param x The argument to test.
 * @param expectedType The required type for the argument.
 * @returns Returns the validated argument, or throws an exception.
 */
function requireType(x, expectedType) {
    if (typeof x !== expectedType) {
        throw new Error(`Expected argument of type ${expectedType}, but got ${typeof x}.`);
    }
    return x;
}
exports.requireType = requireType;
/**
 * Require the text to only have characters from the Basic Multilingual Plane.
 * @param text The word to test.
 * @returns Returns the validated string, or throws an exception.
 */
function requireUnicodeBMP(text) {
    /**
     * ES6 and later Javascript implementations will spread and iterate over strings
     * by Unicode Codepoint, while the rest of the string operations use Code Units
     * (and are unaware of surragate pairs).
     *
     * Example:
     *  MATHEMATICAL BOLD ITALIC CAPITAL A (codepoint: U+1D468)
     *  String.fromCodePoint(0x1D468) == '𝑨'
     *  '\uD835\uDC68' == '𝑨' // Using a surragate pair (internal representation)
     *  '𝑨'.length == 2       // Two code units (the surragate pair)
     *  [...'B𝑨D'].length == 1   // One codepoint
     *
     * '𝑨'.charCodeAt(0)
     *
     * Note: We can make all of this work and remove this limitation, but we need to first
     * have a reason to do it and, second, take the time to make sure it all works properly.
     * */
    if ([...text].length !== text.length) {
        throw new Error("Only Unicode codepoints within the Basic Multilingual Plane (BMP) are supported. The provided string contains values from a supplementary plane.");
    }
    return text;
}
exports.requireUnicodeBMP = requireUnicodeBMP;
/**
 * Determine if a string has a valid Gem format.
 * @param gem The Gem formatted string to verify.
 * @returns Returns the given string if it is valid, else throws an error.
 *
 * Note: We do not require every kanji sequence to have furigana.
 */
function toGemString(gem) {
    requireType(gem, "string");
    requireUnicodeBMP(gem);
    let lastBrace;
    for (let i = 0; i < gem.length; i++) {
        const ch = gem[i];
        if (lastBrace && jpn.isKanjiLike(ch)) {
            throw new Error("Kanji is not allowed inside furigana sequences.");
        }
        if (ch === "[") {
            if (lastBrace) {
                throw new Error("Not allowed to nest furigana sequences.");
            }
            else if (i === 0 || !jpn.isKanjiLike(gem[i - 1])) {
                throw new Error("Furigana may only come after one or more contiguous kanji characters.");
            }
            else {
                lastBrace = ch;
            }
        }
        else if (ch === "]") {
            if (lastBrace !== "[") {
                throw new Error("Matching brackets are required.");
            }
            else {
                if (gem[i - 1] === "[") {
                    throw new Error("Not allowed to have empty furigana sequences.");
                }
                lastBrace = undefined;
            }
        }
    }
    if (lastBrace !== undefined) {
        throw new Error("Matching brackets are required.");
    }
    // ALERT: This should be the ONLY line of code in the entire codebase
    // that casts anything to a GemString. Everything else must use THIS function.
    return gem;
}
exports.toGemString = toGemString;
/**
 * This will look at the word and create a custom regular expression to match
 * the exact sequence of kanji and non-kanji characters in the word.
 * @param word The word to match.
 * @param reading The known reading of the word.
 * @param isGreedy Should the search use greedy matching?
 * @returns Returns a string array of furigana matches for each kanji sequence in the word.
 * Returns undefined if there is no way to match the reading to the word.
 * Returns [] if there is a match, but there is no kanji in the word.
 */
function matchCustomExpression(word, reading, isGreedy) {
    const snippet = isGreedy ? "(.+)" : "(.+?)";
    // Build a custom search expression where we use wilcards for all
    // kanji, but leave everything else in place as required characters.
    // This should "match-up" our reading to our word.
    // Example: "振り仮名" => /(.+)り(.+)/
    let expression = "^";
    let lastIsKanji = false;
    for (const ch of word) {
        const thisIsKanji = jpn.isKanjiLike(ch);
        if (thisIsKanji) {
            if (!lastIsKanji) {
                expression += snippet;
            }
        }
        else {
            expression += ch;
        }
        lastIsKanji = thisIsKanji;
    }
    expression += "$";
    const regex = new RegExp(expression);
    const result = regex.exec(reading);
    if (result == undefined) {
        // Could not find any match for the provided word and reading.
        return undefined;
    }
    // RegEx.match() puts weird stuff in the result, so clean it up before returning it.
    // Skip the first item in the result because it is just the reading -- not an actual match.
    // This may result in an empty array being returned, which is okay.
    // That just means there is no kanji in the word, so nothing to do anyway.
    return result.filter((x, i) => i >= 1 && typeof x === "string");
}
/**
 * Take characters from the word until a condition is met.
 * @param word The word to parse.
 * @param fn The condition to be met.
 * @returns Returns a string array of [<first part>, <remaining part>]
 */
function splitWhen(word, fn) {
    let last = undefined;
    for (let i = 0; i < word.length; i++) {
        const ch = word[i];
        const thisIs = fn(ch);
        if (last != undefined && thisIs !== last) {
            return [word.substring(0, i), word.substring(i)];
        }
        last = thisIs;
    }
    return [word, ""];
}
exports.splitWhen = splitWhen;
/**
 * Splits a string into an array of alternating kanji and non-kanji sequences.
 * @param word The word to split.
 * @returns Returns the array of all of the parts, or [] if there are no parts.
 */
function splitKanjiParts(word) {
    const parts = [];
    let remaining = word;
    while (remaining.length) {
        const comparator = jpn.isKanjiLike(remaining)
            ? jpn.isNotKanjiLike
            : jpn.isKanjiLike;
        const [keep, rest] = splitWhen(remaining, comparator);
        parts.push(keep);
        remaining = rest;
    }
    return parts;
}
/**
 * Attempts to create a GemString from a word and it's reading.
 * @param word The word to parse.
 * @param reading The reading for the word.
 * @returns Returns a validated GemString, or throws an error.
 */
function gemStringFromReading(word, reading) {
    requireType(word, "string");
    if (reading !== undefined) {
        requireType(reading, "string");
    }
    else {
        return toGemString(word);
    }
    if (jpn.hasKanjiLike(reading)) {
        throw new Error("Kanji is not allowed in the reading of a word.");
    }
    // It would be great if a single regex match would be enough, but
    // there are cases where we may not be able to know for sure how
    // to match the reading to the word.
    // We don't have to fix that case, but we do have to detect it.
    // The way I am doing that is trying both a lazy and a greedy query.
    // If they agree with each other, then we can trust our matches.
    // If they don't agree with each other, then a human will have to take a look.
    const regexGreedyMatches = matchCustomExpression(word, reading, true);
    const regexLazyMatches = matchCustomExpression(word, reading, false);
    if (regexGreedyMatches == undefined || regexLazyMatches == undefined) {
        throw new Error("Unable to map the reading to the word.");
    }
    // Do they match?
    const theyBothMatch = regexGreedyMatches.reduce((prev, cur, i) => prev && cur === regexLazyMatches[i], true);
    if (!theyBothMatch) {
        throw new Error("There is no unambiguous way to map the reading to the word.");
    }
    if (regexGreedyMatches.length == 0) {
        // There was nothing (no kanji) in the word for us to match.
        return toGemString(word);
    }
    // The final step is to match the furigana sequences to the kanji in the word.
    const parts = splitKanjiParts(word);
    let gem = "";
    let furiganaIndex = 0;
    const furigana = regexGreedyMatches;
    for (const part of parts) {
        if (jpn.isKanjiLike(part)) {
            gem += `${part}[${furigana[furiganaIndex++]}]`;
        }
        else {
            gem += part;
        }
    }
    // console.log({
    //   word,
    //   reading,
    //   regexGreedyMatches,
    //   regexLazyMatches,
    //   match: theyBothMatch,
    //   parts,
    //   gem,
    // });
    return toGemString(gem);
}
exports.gemStringFromReading = gemStringFromReading;
/**
 * Splits the Gem string into an array of parts.
 * Each part will be a sequence of kanji with optional furigana
 * or a sequence of anything except kanji/furigana.
 * @param gem The Gem string to split.
 * @returns Returns a string array of parts.
 */
function split(gem) {
    const rval = [];
    let kanjiSequence = false;
    let furiganaSequence = false;
    let part = "";
    for (let i = 0; i < gem.length; i++) {
        const c = gem[i];
        const itIsKanji = jpn.isKanjiLike(c);
        if (itIsKanji) {
            if (!kanjiSequence && part) {
                rval.push(part);
                part = "";
            }
            part += c;
            kanjiSequence = true;
        }
        else {
            if (!kanjiSequence) {
                part += c;
            }
            else {
                if (furiganaSequence) {
                    part += c;
                    if (c == "]") {
                        furiganaSequence = kanjiSequence = false;
                        rval.push(part);
                        part = "";
                    }
                }
                else if (c === "[") {
                    furiganaSequence = true;
                    part += c;
                }
                else if (c === " ") {
                    furiganaSequence = kanjiSequence = false;
                    rval.push(part);
                    part = "";
                }
                else {
                    part += c;
                }
            }
        }
    }
    if (part)
        rval.push(part);
    return rval;
}
/**
 * Require every kanji sequence to have furigana.
 * @param gem The Gem string to validated.
 * @returns Returns the validated string, else throws and error.
 */
function requireFurigana(gem) {
    const parts = split(gem);
    for (const part of parts) {
        const hasKanji = jpn.hasKanjiLike(part);
        if (hasKanji) {
            // INTENDED because regexes are funky like this
            // eslint-disable-next-line no-null/no-null
            const hasFurigana = part.match(/.+\[.+\]/) !== null;
            if (hasKanji && !hasFurigana) {
                throw new Error("All kanji sequences must have furigana.");
            }
        }
    }
    return gem;
}
exports.requireFurigana = requireFurigana;
/**
 * Convert a GemString to it's reading.
 * @param gem The string to convert.
 * @returns Returns the reading of the GemString.
 */
function gemToReading(gem) {
    return split(gem)
        .map((x) => {
        const furiganaMatch = x.match(/\[(.+)\]/);
        return furiganaMatch ? furiganaMatch[1] : x;
    })
        .join("");
}
exports.gemToReading = gemToReading;
/**
 * Convert a GemString to it's original text (without furigana).
 * @param gem The string to convert.
 * @returns Returns the word/text of the GemString.
 */
function gemToText(gem) {
    return split(gem)
        .map((part) => {
        const kanjiMatch = part.match(/(.+)\[.+\]/);
        return kanjiMatch ? kanjiMatch[1] : part;
    })
        .join("");
}
exports.gemToText = gemToText;
/**
 * Convert a GemString to an array of it's composable parts.
 * Each part will be either a plain string or a kanji string with it's optional furigana.
 * @param gem The string to convert.
 * @returns Returns an array of GemParts.
 */
function gemToParts(gem) {
    return split(gem).map((part) => {
        const kanjiMatch = part.match(/(.+)\[.+\]/);
        const furiganaMatch = part.match(/\[(.+)\]/);
        if (kanjiMatch && furiganaMatch) {
            return {
                furigana: furiganaMatch[1],
                text: kanjiMatch[1],
            };
        }
        else {
            return {
                text: part,
            };
        }
    });
}
exports.gemToParts = gemToParts;
/**
 * Convert a GemString to an HTML Ruby string.
 * @param gem The string to convert.
 * @returns Returns a string in Ruby format.
 */
function gemToRuby(gem) {
    // 漢字[かんじ]
    // <ruby>漢字<rp>(</rp><rt>かんじ</rt><rp>)</rp></ruby>
    return gemToParts(gem)
        .map((part) => part.furigana === undefined
        ? part.text
        : `<ruby>${part.text}<rp>(</rp><rt>${part.furigana}</rt><rp>)</rp></ruby>`)
        .join("");
}
exports.gemToRuby = gemToRuby;
function gemCombine(...gems) {
    if (gems.length == 0)
        return toGemString("");
    if (gems.length == 1)
        return gems[0];
    /**
     * The simple case is when we aren't dealing with kanji.
     * It only matters if the kanji get matched together, so
     * We only need to check "in the middle", where they would meet.
     * Otherwise, we can just concatenate the two strings.
     */
    function combine(a, b) {
        function toWorkingData(gem, getAdjoiningPart) {
            const parts = gemToParts(gem);
            const adjoiningPart = getAdjoiningPart(parts);
            return {
                adjoiningPart,
                endsWithKanji: jpn.isKanjiLike(adjoiningPart.text[adjoiningPart.text.length - 1]),
                gem,
                hasKanji: jpn.hasKanjiLike(adjoiningPart.text),
                parts,
                startsWithKanji: jpn.isKanjiLike(adjoiningPart.text[0]),
            };
        }
        const first = toWorkingData(a, (x) => x[x.length - 1]);
        const second = toWorkingData(b, (x) => x[0]);
        if ((first.adjoiningPart.furigana && !second.adjoiningPart.furigana) ||
            (!first.adjoiningPart.furigana && !second.adjoiningPart.furigana) ||
            !first.endsWithKanji ||
            !first.startsWithKanji) {
            return toGemString(`${a}${b}`);
        }
        function partToGem(part) {
            return part.text + (part.furigana ? `[${part.furigana}]` : "");
        }
        function partialGem(data) {
            return data.parts
                .filter((x) => x !== data.adjoiningPart)
                .map(partToGem)
                .join("");
        }
        const joined = first.adjoiningPart.furigana
            ? `${first.adjoiningPart.text}${second.adjoiningPart.text}[${first.adjoiningPart.furigana}${second.adjoiningPart.furigana}]`
            : `${first.adjoiningPart.text} ${partToGem(second.adjoiningPart)}`;
        const rval = partialGem(first) + joined + partialGem(second);
        partialGem(first);
        return toGemString(rval);
    }
    const [first, ...remaining] = gems;
    const combined = remaining.reduce((prev, cur) => combine(prev, cur), first);
    return toGemString(combined);
}
exports.gemCombine = gemCombine;
//# sourceMappingURL=GemString.js.map